
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactIndexPriceDialog extends SiteEntityDialog<FactIndexPriceRow, any> {
        protected getFormKey() { return FactIndexPriceForm.formKey; }
        protected getIdProperty() { return FactIndexPriceRow.idProperty; }
        protected getLocalTextPrefix() { return FactIndexPriceRow.localTextPrefix; }
        protected getService() { return FactIndexPriceService.baseUrl; }
        protected getDeletePermission() { return FactIndexPriceRow.deletePermission; }
        protected getInsertPermission() { return FactIndexPriceRow.insertPermission; }
        protected getUpdatePermission() { return FactIndexPriceRow.updatePermission; }

        protected form = new FactIndexPriceForm(this.idPrefix);

    }
}